import { MerchantRecommendedExchangeGroupingType } from "@redotech/redo-model/agents/returns-agents/exchange-agent/merchant-recommended-exchange";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getProductsForExchangeGrouping = {
  name: "getProductsForExchangeGrouping" as const,
  input: z.object({
    groupingType: createEnum(MerchantRecommendedExchangeGroupingType),
    groupingId: z.string(),
  }),
  output: z.object({
    groupingType: createEnum(MerchantRecommendedExchangeGroupingType),
    groupingId: z.string(),
    products: z.array(
      z.object({
        productId: z.string(),
        title: z.string(),
        description: z.string().optional(),
      }),
    ),
  }),
};
